import axios from "axios";
const baseUrl = "c-location";
const province= "c-province"

export default {
    list(params) {
        return axios.post(baseUrl + `/list`, params);
    },
    province(params) {
        return axios.post(province , params);
    },
    district(params) {
        return axios.post('c-district' , params);
    },

};
